var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProjectTypeNewProject(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 24H24V21H27V18H24V15H21V18H18V21H21V24ZM6 30C5.175 30 4.46875 29.7063 3.88125 29.1188C3.29375 28.5312 3 27.825 3 27V9C3 8.175 3.29375 7.46875 3.88125 6.88125C4.46875 6.29375 5.175 6 6 6H15L18 9H30C30.825 9 31.5313 9.29375 32.1188 9.88125C32.7063 10.4688 33 11.175 33 12V27C33 27.825 32.7063 28.5312 32.1188 29.1188C31.5313 29.7063 30.825 30 30 30H6ZM6 27H30V12H16.7625L13.7625 9H6V27Z",
    fill: "#0094FB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectTypeNewProject);
export default __webpack_public_path__ + "static/media/projectType_newProject.d5560f9b213f363e0f022fd58657cfad.svg";
export { ForwardRef as ReactComponent };